import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/service/rest.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-eqac',
  templateUrl: './eqac.component.html',
  styleUrls: ['./eqac.component.css']
})
export class EqacComponent implements OnInit {

  // The Quality Assurance Center is construction id 11 (subdomain: eqac).
  readonly EQAC_ID = 11

  data: any = {}            // GetConstructionDetails(11)
  sections: any[] = []      // subdetailslist (director word, role, vision, mission, goals, tasks, boards)
  gallery: any[] = []
  news: any[] = []          // latest news for the home / activities archive

  // Tab map mirrors the center's tab plan.
  activeTab:
    'home' | 'about' | 'activities' | 'courses' | 'units' | 'reviews' | 'contact' = 'home'

  // Sub-tab inside "عن المركز".
  aboutTab: 'about' | 'management' | 'structure' = 'about'

  // Cairo / Alexandria QA units (static list from the center's tab plan; no API yet).
  cairoUnits: string[] = [
    'وحدة ضمان الجودة للمعهد العالي للسينما',
    'وحدة ضمان الجودة للمعهد العالي للفنون المسرحية',
    'وحدة ضمان الجودة للمعهد العالي للفنون الشعبية',
    'وحدة ضمان الجودة للمعهد العالي لفنون الطفل',
    'وحدة ضمان الجودة للمعهد العالي للموسيقى العربية',
    'وحدة ضمان الجودة للمعهد العالي لموسيقى الكونسرفاتوار',
    'وحدة ضمان الجودة للمعهد العالي للنقد الفني',
    'وحدة ضمان الجودة للمعهد العالي للباليه',
    'وحدة ضمان الجودة للمعهد العالي لترجمات الفنون والآداب والوسائط الفنية',
  ]
  alexUnits: string[] = [
    'وحدة ضمان الجودة للمعهد العالي للسينما',
    'وحدة ضمان الجودة للمعهد العالي للفنون المسرحية',
    'المعهد العالي للنقد الفني',
  ]

  // Important external links (URLs to be supplied later).
  importantLinks: { name: string, url: string }[] = [
    { name: 'الهيئة القومية لضمان جودة التعليم والاعتماد', url: '' },
    { name: 'وزارة الثقافة', url: '' },
    { name: 'المجلس الأعلى للجامعات', url: '' },
  ]

  constructor(private rest: RestService, private router: Router) { }

  ngOnInit(): void {
    window.scrollTo(0, 0)
    this.getData()
    this.getNews()
  }

  getData() {
    this.rest.getConstrction(this.EQAC_ID).subscribe((res: any) => {
      this.data = res || {}
      this.sections = res?.subdetailslist || []
      this.gallery = res?.gallery || []
    })
  }

  getNews() {
    this.rest.getConstructionNews(12, 1, this.EQAC_ID).subscribe((res: any) => {
      this.news = res?.LatestNews || []
    })
  }

  setTab(tab) {
    this.activeTab = tab
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  // Returns the first subdetail section whose NAME contains the given keyword.
  section(keyword: string) {
    return (this.sections || []).find(s => this.norm(s?.NAME).includes(this.norm(keyword)))
  }

  // Sections used for the management sub-tab (boards) vs. the about sub-tab.
  get managementSections() {
    return (this.sections || []).filter(s => this.norm(s?.NAME).includes('مجلس'))
  }
  get aboutSections() {
    // Exclude: boards (shown under "إدارة المركز"), the director's word (its own
    // card at the top), and vision/mission (shown in the timeline block).
    return (this.sections || []).filter(s => {
      const n = this.norm(s?.NAME)
      return !n.includes('مجلس') && !n.includes('كلمه مدير')
        && !n.includes('رؤيه') && !n.includes('رساله')
    })
  }

  get visionSection() { return this.section('رؤيه') }
  get missionSection() { return this.section('رساله') }

  newsDetails(item) {
    this.router.navigate(['/news_details', item.ID])
  }

  has(value): boolean {
    if (!value) { return false }
    const v = String(value).trim()
    return v.length > 0 && v !== '.'
  }

  private norm(text): string {
    return String(text || '')
      .toLowerCase()
      .replace(/[أإآ]/g, 'ا')
      .replace(/ى/g, 'ي')
      .replace(/ة/g, 'ه')
      .replace(/\s+/g, ' ')
      .trim()
  }
}
